$(function(){
  
    //scroll
   $('.container a[href^=#]').click(function(){
     //var sumahokuji = 500;
     var href= $(this).attr("href");
     var target = $(href == "#" || href == "" ? 'html' : href);
     //var position = target.offset().top;
     var position = target.offset().top - 120;
 
     //$("html, body").animate({scrollTop:position}, sumahokuji, "swing");
     $("html, body").animate({scrollTop:position}, "slow", "swing");
     return false;
   });
   
   //toggle
   $('.tgl_btn').click(function(){
     $(this).next(".tgl_lst").slideToggle();
     $(this).toggleClass('active');
     //$(this).parent().toggleClass('active');
     //$(".itemlist_ttl").toggleClass('active');
   });
   
     //pagetop
   $(".pagetop").hide();
 
   $(window).on("scroll", function() {
     if ($(this).scrollTop() > 100) {
       $('.pagetop').fadeIn();
     }else{
       $('.pagetop').fadeOut();
     }
   });
   
 });
 